
// eslint-disable-next-line import-x/no-extraneous-dependencies
export * from '#fe-shared/index';
// eslint-disable-next-line import-x/no-extraneous-dependencies
export * from '#fe-shared/types/dbs/api/types';

export type NoShowError = Error & { no_show_error?: true };
export function noShowError(message?: string) {
    const err: NoShowError = new Error(message ?? 'cancelled');
    err.no_show_error = true;
    return err;
}

export function Vueset<T extends Record<PropertyKey, unknown>, K extends keyof T>(
    record: T,
    propName: K,
    value: T[K],
): void;
export function Vueset<T extends unknown[]>(
    record: T,
    index: number,
    value: T[number],
): void;
export function Vueset(
    record: unknown,
    propName: PropertyKey,
    value: unknown,
): void {
    if(!record) {
        return;
    }
    record[propName] = value;
}
